import React from 'react';
import { Flex, Box } from '@withjoy/joykit';
import { pxToRem } from '@withjoy/joykit/theme';
import { SkeletonText } from '@shared/components/Skeleton';

const CONTAINER_BASE_WIDTH_PX = 590;

export const PlaceToStayComponentSkeleton: React.FC = () => {
  return (
    <Flex
      textAlign="center"
      width={{ _: '100%', sm2: CONTAINER_BASE_WIDTH_PX }}
      maxWidth={pxToRem(590)}
      margin="0 auto"
      flexDirection="column"
      rowGap={pxToRem(40)}
    >
      {/* Hotel Name and Address */}
      <Flex
        flexDirection="column"
        alignItems="center"
        rowGap={5}
        width="100%"
      >
        {/* Hotel Name */}
        <Box
          display="flex"
          justifyContent="center"
          width={pxToRem(292)}
        >
          <SkeletonText
            rows={1}
            skeletonHeight={pxToRem(24)}
            width="100%"
          />
        </Box>
        {/* Address */}
        <Box
          display="flex"
          justifyContent="center"
          alignItems="center"
          columnGap={pxToRem(8)}
          width={pxToRem(350)}
        >
          <SkeletonText
            rows={1}
            skeletonHeight={pxToRem(16)}
            width="100%"
          />
        </Box>
      </Flex>

      {/* Note/Description */}
      <Flex
        width="100%"
        flexDirection="column"
        rowGap={pxToRem(16)}
        textAlign="center"
      >
        <SkeletonText
          rows={3}
          width="100%"
          skeletonHeight={pxToRem(16)}
        />
      </Flex>

      {/* View Hotel Button */}
      <Flex
        justifyContent="center"
        marginTop={pxToRem(7)}
        width="100%"
      >
        <Box width={{ _: '100%', sm2: pxToRem(292) }}>
          <SkeletonText
            rows={1}
            width="100%"
            skeletonHeight={pxToRem(44)}
          />
        </Box>
      </Flex>
    </Flex>
  );
};
